
export const authConfig = {
  auth: {
    clientId: import.meta.env.CLIENT_ENTRA_CLIENT_ID,
    authority: import.meta.env.CLIENT_ENTRA_AUTHORITY_URL,
    redirectUri: import.meta.env.CLIENT_AUTH_REDIRECT_URI,
    postLogoutRedirectUri: '/logout',
  },
  cache: {
    cacheLocation: "localStorage", // Works better than sessionStorage for cross-tab SSO
    storeAuthStateInCookie: true,   // Critical for Safari/IE compatibility
  }
};